import PaymentForm from "./components/PaymentInvoicePresentation";

export const PaymentInvoicePage = (): JSX.Element => {
	return <PaymentForm />;
};
